module.exports = __webpack_public_path__ + "static/media/Commercial Policy.520b9361.svg";